import { render, staticRenderFns } from "./PlaceHolderButton.vue?vue&type=template&id=228f3dee&"
import script from "./PlaceHolderButton.vue?vue&type=script&lang=js&"
export * from "./PlaceHolderButton.vue?vue&type=script&lang=js&"
import style0 from "./PlaceHolderButton.vue?vue&type=style&index=0&id=228f3dee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports